import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router'
import {Observable} from 'rxjs'
import {ConfigSource} from '../common/domain/config'
import {ApiService} from '../services/api.service'
import {GetConfigFileResponse} from '../model/config-responses'

@Injectable({providedIn: 'root'})
export class LatestConfigResolver implements Resolve<GetConfigFileResponse> {
  constructor(private api: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GetConfigFileResponse> {
    const pService = route.paramMap.get('service')
    const service: ConfigSource = pService === 'docgen'
      ? 'lambda-ingest-product'
      : pService === 'publish'
        ? 'api-publish'
        : pService as ConfigSource
    const sourceSystem = route.paramMap.get('sourceSystem')
    const p1 = route.paramMap.get('p1')
    const p2 = route.paramMap.get('p2')
    const p3 = route.paramMap.get('p3')

    return this.api.get<GetConfigFileResponse>(`/config/latest/${service}/config/settings/${sourceSystem}/${p1}/${p2}/${p3}/Config.json`)
  }
}
